export default __webpack_public_path__ + "static/media/home-qualification31mobile.3aadf8f5.png";